import { useEffect, useRef, useState } from "react";
import MapDrag from "./MapWithSearch";

const Map = ({ onLocationChange, defaultValue }) => {
  const [markerPosition, setMarkerPosition] = useState(null);
  const autocompleteRef = useRef(null);
  const handleMarkerDragEnd = (position) => {
    const newPosition = {
      lat: position?.lat(),
      lng: position?.lng(),
    };
    setMarkerPosition(newPosition);
    if (onLocationChange) onLocationChange(newPosition);
  };

  const handlePlaceSelected = () => {
    const autocomplete = autocompleteRef?.current;
    const place = autocomplete?.getPlace();

    if (place?.geometry) {
      const newPosition = {
        lat: place?.geometry?.location?.lat(),
        lng: place?.geometry?.location?.lng(),
      };
      setMarkerPosition(newPosition);
      if (onLocationChange) onLocationChange(newPosition);
    }
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position?.coords;
        const newPosition = {
          lat: defaultValue?.[1] ?? latitude,
          lng: defaultValue?.[0] ?? longitude,
        };
        setMarkerPosition(newPosition);
        if (onLocationChange) onLocationChange(newPosition);
      },
      (error) => {
        console.error("Error getting user's location:", error?.message);
        const defaultPosition = {
          lat: defaultValue?.[1] ?? 37.5485396,
          lng: defaultValue?.[0] ?? -121.988583,
        };
        setMarkerPosition(defaultPosition);
        if (onLocationChange) onLocationChange(defaultPosition);
      }
    );
  }, []);
  if (markerPosition) {
    localStorage.setItem("Longitude", markerPosition?.lng);
    localStorage.setItem("Latitude", markerPosition?.lat);
  }
  return (
    <div>
      <MapDrag
        onMarkerDragEnd={handleMarkerDragEnd}
        markerPosition={markerPosition}
        onPlaceSelected={handlePlaceSelected}
        autocompleteRef={autocompleteRef}
      />
    </div>
  );
};

export default Map;
